import { Box, BoxContent } from "components/Box/Box";
import Chart from "components/Charts/Chart";

const BarChart = ({ series, icon, labels, prefix, colors }: any) => {
  const options = {
    options: {
      colors: colors,
      dataLabels: {
        enabled: true,
        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
          return (
            w.config.labels[seriesIndex] +
            ":  " +
            numberWithCommas(parseFloat(value.toFixed(2))) +
            "%"
          );
        },
        dropShadow: {
          enabled: false,
        },
        style: {
          colors: ["#5B5B5B"],
        },
      },
      labels: labels,
      legend: {
        show: false,
      },
      stroke: {
        show: false,
      },
      states: {
        hover: {
          filter: {
            type: "darken",
            value: 0.8,
          },
        },
      },
      plotOptions: {
        pie: {
          donut: {},
          expandOnClick: false,
        },
      },
    },
    series: series,
  };

  const numberWithCommas = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <Box>
      <BoxContent style={{ display: "block", padding: "2rem 0" }}>
        <Chart
          options={options.options}
          series={options.series}
          // height="350"
          width="100%"
          type="pie"
        />
      </BoxContent>
    </Box>
  );
};

export default BarChart;
